const campaignTriggerTypes = Object.freeze({
  TRIGGER_NONE: 0,
  TRIGGER_LOCATION: 1,
  TRIGGER_EVENT: 2,
  TRIGGER_API: 3,
  TRIGGER_OPTIMOVE: 4,
  TRIGGER_SALESFORCE: 6,
  TRIGGER_ACCUMULATION: 7
})

export { campaignTriggerTypes }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignTriggerTypesEnum.js